import { Monitor, Server, Database, Cloud } from "lucide-react";

export default function TechStack() {
  const techStacks = [
    {
      icon: Monitor,
      title: "Frontend",
      color: "text-sprintwise-primary",
      technologies: [
        { name: "React/Next.js", level: 92 },
        { name: "Angular", level: 85 },
        { name: "Vue.js", level: 85 },
        { name: "TypeScript", level: 90 }
      ]
    },
    {
      icon: Server,
      title: "Backend",
      color: "text-sprintwise-secondary",
      technologies: [
        { name: "Node.js", level: 90 },
        { name: "Python", level: 85 },
        { name: "Go", level: 75 },
        { name: ".NET", level: 70 }
      ]
    },
    {
      icon: Database,
      title: "Базы данных",
      color: "text-sprintwise-accent",
      technologies: [
        { name: "PostgreSQL", level: 90 },
        { name: "MongoDB", level: 85 },
        { name: "Redis", level: 80 },
        { name: "MySQL", level: 75 }
      ]
    },
    {
      icon: Cloud,
      title: "DevOps",
      color: "text-green-500",
      technologies: [
        { name: "Docker", level: 90 },
        { name: "Kubernetes", level: 85 },
        { name: "AWS", level: 80 },
        { name: "CI/CD", level: 75 }
      ]
    }
  ];

  return (
    <section id="tech" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-sprintwise-dark mb-6" data-testid="tech-title">
            Стек <span className="gradient-text">технологий</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-testid="tech-description">
            Используем проверенные и современные технологии для создания масштабируемых решений
          </p>
        </div>
        
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {techStacks.map((stack, stackIndex) => (
            <div key={stackIndex} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300" data-testid={`tech-stack-${stackIndex}`}>
              <h3 className="text-xl font-semibold text-sprintwise-dark mb-4 flex items-center" data-testid={`tech-stack-title-${stackIndex}`}>
                <stack.icon className={`${stack.color} mr-3`} />
                {stack.title}
              </h3>
              <div className="space-y-3">
                {stack.technologies.map((tech, techIndex) => (
                  <div key={techIndex} className="flex items-center justify-between" data-testid={`tech-item-${stackIndex}-${techIndex}`}>
                    <span className="text-gray-700" data-testid={`tech-name-${stackIndex}-${techIndex}`}>{tech.name}</span>
                    <div className="w-12 h-2 bg-gray-200 rounded-full">
                      <div 
                        className={`h-2 rounded-full bg-gradient-to-r ${
                          stackIndex === 0 ? 'from-sprintwise-primary to-sprintwise-secondary' :
                          stackIndex === 1 ? 'from-sprintwise-secondary to-sprintwise-accent' :
                          stackIndex === 2 ? 'from-sprintwise-accent to-sprintwise-primary' :
                          'from-green-500 to-blue-500'
                        }`}
                        style={{ width: `${tech.level}%` }}
                        data-testid={`tech-level-${stackIndex}-${techIndex}`}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
